import { FormControl } from '@angular/forms';

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export const positiveNumberValidator = (control: FormControl) => {
  if (!control.value) {
    return null;
  }

  if (!isNumber(control.value) || control.value < 0) {
    return {
      validatePositiveNumber: {
        valid: false
      }
    };
  }

  return null;
};
